
import React, { useEffect } from 'react';
import { Page } from '@components/page';
import { LeftOutlined } from '@ant-design/icons';
import { useDispatch } from 'react-redux';
import { Body } from './components/body';
import { CardTable } from '@components/table/styled';
import { Col } from 'antd';
import { translate } from '@components/i18n';
import { fetchAuthorizedClients } from '@redux/slices/authorized-clients';

export const AuthorizedClients: React.FC = () => {
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(fetchAuthorizedClients());
    }, []);

    return (
        <Page
            title={translate('pages.authorizedClients')}
            greyBackground
            onClickGoBack
            menuIcon={<LeftOutlined />}
        >
            <Col span={22} style={{ alignSelf: 'center' }}>
                <h2 style={{ marginTop: '15px' }}>
                    {translate('titlePages.authorizedClients')}
                </h2>
                <CardTable>
                    <Body />
                </CardTable>
            </Col>
        </Page>
    );
};
